(window as any).__Zone_disable_requestAnimationFrame = true; // Desativa o patch para requestAnimationFrame
(window as any).__Zone_disable_on_property = true;           // Desativa o patch para eventos como onClick
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove']; // Ignora eventos de scroll e mousemove
